import { render } from "./FAQItem.vue?vue&type=template&id=48467a15&scoped=true"
import script from "./FAQItem.vue?vue&type=script&lang=js"
export * from "./FAQItem.vue?vue&type=script&lang=js"

import "./FAQItem.vue?vue&type=style&index=0&id=48467a15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48467a15"]])

export default __exports__